import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

import React from 'react';

import styles from '../Modal.module.scss';

const cx = classNames.bind(styles);

const ModalHeader = ({ children, className = '', hasTitle = false, ...rest }) => (
  <div className={cx('modal__header', className)} {...rest}>
    <div className={cx({ 'has-title': hasTitle })}>{children}</div>
  </div>
);

ModalHeader.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.oneOfType([PropTypes.array, PropTypes.string, PropTypes.object]),
  hasTitle: PropTypes.bool,
};

ModalHeader.displayName = 'ModalHeader';

export default ModalHeader;
